import { FC } from 'react'

import styles from '../../styles/Product.module.less'

const EditProductIcon: FC = () => (
  <svg
    className={styles['edit-product-icon']}
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.5"
      cy="12.5"
      r="12"
      stroke="#62BFAD"
    />
    <g clipPath="url(#clip0_15033_115629)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.72929 16.6214L17.1005 9.25027C17.3337 9.01705 17.3444 8.68371 17.168 8.50729L16.4926 7.83185C16.3161 7.65543 15.9828 7.66618 15.7496 7.8994L8.37842 15.2706L7.97316 17.0267L9.72929 16.6214ZM17.7756 9.9258L10.4135 17.2879C10.281 17.4204 10.1139 17.513 9.93127 17.5552L7.01026 18.2292C6.86625 18.2625 6.73718 18.1334 6.77041 17.9894L7.44449 15.0684C7.48663 14.8858 7.57925 14.7187 7.71177 14.5861L15.0739 7.22406C15.6707 6.6272 16.6082 6.59696 17.1677 7.15651L17.8431 7.83195C18.4027 8.3915 18.3724 9.32895 17.7756 9.9258Z"
        fill="#62BFAD"
      />
    </g>
    <defs>
      <clipPath id="clip0_15033_115629">
        <rect
          width="13"
          height="13"
          fill="white"
          transform="translate(6 6)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default EditProductIcon
